// import axios from 'axios'

export default {
    namespaced: true,
    state: {
        missedCalls: [{
            number: "+13030303030",
            updatedAt: new Date(Date.now()),
        },],
        loadingCalls: false,
    },
    mutations: {
        SET_LOADING_CALLS(state, loading) {
            state.loadingCalls = loading;
        },
        SET_MISSED_CALLS(state, calls) {
            state.missedCalls = calls;
        },
        ADD_MISSED_CALL(state, call) {
            state.missedCalls.push(call);
        },
        DELETE_MISSED_CALL(state, call_id) {
            const index = state.missedCalls.findIndex(script => script.id === call_id);

            state.missedCalls.splice(index, 1);
        },
    },
    getters: {
        missedCalls: state => state.missedCalls,
        loadingCalls: state => state.loadingCalls,
    },
    actions: {
        // loadMissedCalls({ commit }) {

        // },
    },
}
